import 'jquery.iframetracker';
import $ from 'jquery';


function getThumbnailUrl(el, accountUrl) {

  $.getJSON('https://fast.wistia.com/oembed/?url=' + accountUrl + "&format=json&callback=?", function(data){
          var thumb = data.thumbnail_url.split('?')[0];
          if (el.hasClass('video-archive-hero__image')) {
            thumb += "?image_crop_resized=750x750";
          } else if ($('body').hasClass('post-type-archive-video')) {
            thumb += "?image_crop_resized=500x500";
          } else {
            thumb += "?image_crop_resized=350x350";
          }

          el.children('img').attr('src', thumb);
  })
}


export const embedPlayer = () => {
  $('.video-embed__container, .wp-block-embed__wrapper').iframeTracker(function (e) {
    $('.video-player-button').attr('hidden', true);
  });

  $('[data-type="wistia"]').each(function(){

    var el = $(this);
    var baseUrl = $(this).attr('data-src');
    var accountUrl = encodeURIComponent(baseUrl);
    getThumbnailUrl(el, accountUrl);


  });
};
